import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from "../hooks/useAuthStore";
import { useT } from "../i18n";
import LanguageSwitch from "../components/common/LanguageSwitch";
import './LoginPage.css';

// 自助注册已下线 (后端 /auth/register/ 一并移除), 账号由管理员在服务器上用
// manage.py provision_demo_account 开通。这里只保留登录。
export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, loading } = useAuthStore();
  const navigate = useNavigate();
  const t = useT();

  // 把后端校验报错转成可读文本
  const formatError = (e: any, fallback: string) => {
    const status = e?.response?.status;
    const d = e?.response?.data;
    const tag = status ? `[${status}] ` : (e?.message ? `[${e.message}] ` : '');
    if (!d && (!status || status >= 500)) {
      return tag + t('后端服务暂不可用，请确认后端已启动');
    }
    if (!d) return tag + fallback;
    if (typeof d === 'string') return tag + d;
    if (d.detail) return tag + d.detail;
    // DRF 字段级错误: {username: ["..."], password: ["..."]}
    const first = Object.entries(d)[0];
    if (first) {
      const [k, v] = first;
      const msg = Array.isArray(v) ? v[0] : String(v);
      return `${tag}${k}: ${msg}`;
    }
    return tag + fallback;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await login(username, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError(formatError(err, t('用户名或密码错误')));
    }
  };

  return (
    <div className="login-page">
      <LanguageSwitch style={{ position: 'fixed', top: 16, right: 20, zIndex: 10 }} />
      <div className="login-bg">
        <div className="grid-overlay" />
        <div className="glow-orb orb-1" />
        <div className="glow-orb orb-2" />
      </div>

      <div className="login-card">
        <div className="login-header">
          <span className="login-logo">⬡</span>
          <h1>FracSight</h1>
          <p>{t('石油压裂智能平台')}</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('用户名')}</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={t('请输入用户名')}
              autoComplete="username"
              required
            />
          </div>

          <div className="form-group">
            <label>{t('密码')}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('请输入密码')}
              autoComplete="current-password"
              required
            />
          </div>

          {error && <div className="form-error">{error}</div>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? t('登录中...') : t('登 录')}
          </button>
        </form>

        <div className="login-footer">
          <span>{t('账号由管理员统一开通')}</span>
        </div>
      </div>
    </div>
  );
}
